module.exports = __webpack_public_path__ + "static/media/gb.f86493e0.svg";